import { render, staticRenderFns } from "./BwsE3.vue?vue&type=template&id=71b65480"
import script from "./BwsE3.vue?vue&type=script&lang=js"
export * from "./BwsE3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports